<template>
      <div>
        <div class="calendar__label-container flex">
          <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
        </div>

            <p class="label">* Paciente</p>
            <v-select
              :options="patientOptions" 
              @search="fetchOptions"
              v-model="selectedPatient"
              :reduce="patientOptions => patientOptions" 
              :required="!selectedPatient" 
              @input="setPatient"
              placeholder="digite aqui..."
              label="name">
            </v-select>

            <vs-input name="event-name" hidden v-validate="'required'" class="w-full" v-model="title" ></vs-input>
            
            <div class="my-4">
                <p class="label">* Data da consulta</p>
                <datepicker name="start-date" format="dd/MM/yyyy" v-model="startDate" :disabled="disabledFrom" required></datepicker>
            </div>

            <div class="my-4">
              <p class="label">* Horário da consulta</p>
              <flat-pickr :config="configdateTimePicker" v-model="scheduleTime" placeholder="selecione..." v-validate="'required'"/>
            </div>

            <div class="my-4">
              <p class="label warning">* (Campo obrigatório)</p>
            </div>
      </div>
</template>

<script>
// DateTimePicker
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Datepicker from 'vuejs-datepicker';

import vSelect from 'vue-select'

require("vue-simple-calendar/static/css/default.css");

import PatientService from '../../../services/PatientService';

export default {
  props: {
    prop_startDate: Date,
    prop_title: String,
    prop_scheduleTime: Date,
    prop_patient: Object,
  },
  data() {
    return {
      notifications: 
      {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      exportData: {
        eventName: "",
        scheduleDate: "",
        patient: "",
        scheduleTime: ""
      },
      disabledFrom: false,
      id: 0,
      patient: this.prop_patient,
      title: this.prop_title,
      startDate: this.prop_startDate,
      endDate: this.prop_startDate,
      scheduleTime: this.prop_scheduleTime,
      labelLocal: 'none',
      url: '',
      calendarView: 'month',
      activePromptAddEvent: false,
      activePromptEditEvent: false,
      selectedPatient: this.prop_title,
      patientOptions: [
      ],
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'H:i',
        noCalendar: true,
        time_24hr: true,
      }
    }
  },
  components: {
    flatPickr,
    Datepicker,
    'v-select': vSelect,
  },
  methods: {
    async fetchOptions (search, loading) {
      loading(true);

      if(search.length >= 2)
      {
        var payload = {
          data: {
            nameLike: search,
          },
          notifications: this.notifications
        };

        var result = await PatientService.search(payload);

        this.patientOptions = result.data;
      }

      loading(false);
    },
    setPatient(patient) {
      this.selectedPatient = "";
      this.title = "";
      this.patient = null;
      
      if(patient != null)
      {
        this.selectedPatient = patient.name;
        this.title = patient.name;
        this.patient = patient;        
      }
    },
    updateExportData() {
      this.exportData.eventName = this.title;
      this.exportData.scheduleDate =  this.startDate;
      this.exportData.patient = this.patient;

      if(this.scheduleTime != null) {
        console.log("scheduleTime", this.scheduleTime);
        if(this.scheduleTime instanceof Date) {
          this.exportData.scheduleTime = this.scheduleTime;
        } else {
          var date = new Date(this.startDate);
          var hour = parseInt(this.scheduleTime.substring(0, 2));
          var minute = parseInt(this.scheduleTime.substring(3, 5));
          date.setHours(hour, minute, 0, 0 );
          this.exportData.scheduleTime = date;
        }
      }

      this.$emit("AppointmentScheduleCreateChanged", this.exportData);
    }
  },
  computed: {
    labelColor() {
        return (label) => {
            if (label == "business") return "success"
            else if (label == "work") return "warning"
            if (label == "personal") return "danger"
            if (label == "none") return "primary"
        }
    }
  },
  watch: {
    title: function() {
      this.updateExportData();
    },
    startDate: function() {
      this.updateExportData();
    },
    patient: function() {
      this.updateExportData();
    },
    scheduleTime: function() {
      this.updateExportData();
    }
  }
}
</script>

<style scoped>
  .label {
    padding-left: 5px;
    font-size: .85rem;
    color: rgba(0,0,0,.7);
  }
</style>